import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';

const SUPPORTED = ['en', 'fr', 'ar'];
const saved = (() => {
  try { return localStorage.getItem('lang'); } catch (_) { return null; }
})();
const initialLang = SUPPORTED.includes(saved) ? saved : 'en';

// Apply text direction + lang attribute (Arabic is right-to-left).
export const applyDirection = (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  if (typeof document !== 'undefined') {
    document.documentElement.dir = dir;
    document.documentElement.lang = lng;
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ar: { translation: ar },
    },
    lng: initialLang,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

applyDirection(initialLang);

i18n.on('languageChanged', (lng) => {
  try { localStorage.setItem('lang', lng); } catch (_) {}
  applyDirection(lng);
});

export default i18n;
